import Swiper from 'swiper/bundle';
import scrollMonitor from 'scrollmonitor';
import DropdownMenu from './dropdown-menu';
import { isTouch } from './utils';

const $document = $(document);
const $window = $(window);
const $body = $('body');

if (isTouch()) {
	$body.addClass('is-touch');
}

// Header
(function() {
	$('button[data-action="header-open-overlay"]').on('click', function(e) {
		$body.addClass('header-overlay-active');
		$('header .header__bar a, main a, footer a').attr('tabindex', -1);
	});

	$('button[data-action="header-close-overlay"]').on('click', function(e) {
		$body.removeClass('header-overlay-active');
		$('header .header__bar a, main a, footer a').removeAttr('tabindex');
	});
})();

// Carousel
$('.carousel').each(function() {
	const $carousel = $(this);
	const $mainSwiper = $carousel.find('.carousel__main__swiper');
	const $thumbnailSwiper = $carousel.find('.carousel__thumbnails__swiper');
	const hasThumbnails = $thumbnailSwiper.length > 0;
	const mainSwiperOptions = {
		spaceBetween: 20, // --space-125/--column-gap
		simulateTouch: false,
		navigation: {
			nextEl: $carousel.find('.carousel__main__next').get(0),
			prevEl: $carousel.find('.carousel__main__prev').get(0),
		},
	};
	const thumbnailSwiperOptions = {
		spaceBetween: 20, // --space-125/--column-gap
		slidesPerView: 3,
		breakpoints: {
			640: {
    		slidesPerView: 4,
      }
    },
		watchSlidesProgress: true,
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: false,
      draggable: true,
    },
    mousewheel: {
    	invert: false,
    	forceToAxis: true,
    },
	  freeMode: {
	    enabled: true,
	    sticky: false,
	  },
		grabCursor: false,
		on: {
			scrollbarDragStart: function(s, e) {
				s.$el.find('.swiper-scrollbar')
					.addClass('swiper-scrollbar-active');
				$body
					.addClass('swiper-scrollbar-active');
			},
			scrollbarDragEnd: function(s, e) {
				s.$el.find('.swiper-scrollbar')
					.removeClass('swiper-scrollbar-active');
				$body
					.removeClass('swiper-scrollbar-active');
			},
		},
	};

	if (hasThumbnails) {
		const thumbnailSwiper = new Swiper(
			$thumbnailSwiper.get(0),
			thumbnailSwiperOptions
		);

		mainSwiperOptions.thumbs = {
			swiper: thumbnailSwiper,
		};

		mainSwiperOptions.effect = 'slide';
	} else {
		mainSwiperOptions.scrollbar = {
      el: ".swiper-scrollbar",
      hide: false,
      draggable: true,
    };

    mainSwiperOptions.effect = 'slide';

		mainSwiperOptions.on = {
			scrollbarDragStart: function(s, e) {
				s.$el.find('.swiper-scrollbar')
					.addClass('swiper-scrollbar-active');
				$body
					.addClass('swiper-scrollbar-active');
			},
			scrollbarDragEnd: function(s, e) {
				s.$el.find('.swiper-scrollbar')
					.removeClass('swiper-scrollbar-active');
				$body
					.removeClass('swiper-scrollbar-active');
			},
		};
	}

	const mainSwiper = new Swiper(
		$mainSwiper.get(0),
		mainSwiperOptions,
	);
});

// Accordion
$('button.accordion__heading').on('click', function(e) {
	e.preventDefault();

	const $button = $(this);
	const $item = $button.closest('li.accordion__item');
	const $icon = $button.find('svg.accordion-item-header__icon');

	$item.toggleClass('accordion__item--active');
	$icon.toggleClass('svg-icon--rotate-180');
	$button.attr('aria-expanded',
		$button.attr('aria-expanded') == 'true' ?
			'false' : 'true'
	);
});

// Tabs
$('button.tabs__tab').on('click', function(e) {
	e.preventDefault();

	const $button = $(this);
	const $siblingButtons = $button.siblings();
	const $tab = $('div.tabs__panel#' + $button.attr('aria-controls'));
	const $siblingTabs = $tab.siblings('.tabs__panel');

	$button
		.addClass('tabs__tab--active')
		.attr('aria-selected', 'true');
	$siblingButtons
		.removeClass('tabs__tab--active')
		.attr('aria-selected', 'false');

	$siblingTabs.attr('hidden', '');
	$tab.removeAttr('hidden');
});

// Overflow carousel
$('.overflow-carousel').each(function() {
	const $carousel = $(this);
	const $content = $carousel.find('div.overflow-carousel__content');
	const $prevButton = $carousel
		.find('button[aria-controls="overflow-carousel__default-prev-btn"]');
	const $nextButton = $carousel
		.find('button[aria-controls="overflow-carousel__default-next-btn"]');
	let maxScroll = $content.get(0).scrollWidth - $content.width();

	$window.on('resize', (e) => {
		maxScroll = $content.get(0).scrollWidth - $content.width();
		$content.trigger('scroll');
	});

	$prevButton.on('click', (e) => {
		e.preventDefault();

		$content.get(0).scrollTo({
			left: $content.scrollLeft() - 200,
			behavior: 'smooth'
		});
	});

	$nextButton.on('click', (e) => {
		e.preventDefault();

		$content.get(0).scrollTo({
			left: $content.scrollLeft() + 200,
			behavior: 'smooth'
		});
	});

	$content.on('scroll', (e) => {
		const scrollLeft = $content.scrollLeft();

		if (scrollLeft <= 0) {
			$prevButton
				.addClass('overflow-carousel__button--hidden');
		} else {
			$prevButton
				.removeClass('overflow-carousel__button--hidden');
		}

		if (scrollLeft >= maxScroll) {
			$nextButton
				.addClass('overflow-carousel__button--hidden');
		} else {
			$nextButton
				.removeClass('overflow-carousel__button--hidden');
		}
	});

	$content.trigger('scroll');
});

// Dropdown menu
new DropdownMenu();	// Default settings

// Nav
new DropdownMenu({
	itemSelector: '.nav li.menu-item-has-children',
	toggleSelector: '> a',
	popupSelector: '> ul.sub-menu',
	popupActiveClassname: 'sub-menu--open',
	popupActiveAttr: true,
	popupUpClassname: 'sub-menu--up',
	popupLeftClassname: 'sub-menu--left'
});

// Section hero slideshow
$('.section-hero__slideshow .swiper').each(function(index, el) {
	new Swiper(el, {
		effect: 'fade',
		loop: true,
		autoplay: {
			delay: 2000,
			disableOnInteraction: false,
		},
		simulateTouch: false,
	});
});

// Section grillen hero
$('.section-grillen-hero').each(function(index,el) {
	const $section = $(el);
	const $cta = $section.find('.section-grillen-hero__cta');

	if ($cta.length > 0) {
		const ctaWatcher = scrollMonitor.create($cta.get(0));
		const $footer = $('.footer');
		const footerWatcher = scrollMonitor.create($footer.get(0));

		ctaWatcher.enterViewport(() => {
			$section.
				removeClass('section-grillen-hero--sticky-bar-visible');
		});

		ctaWatcher.exitViewport(() => {
			$section.
				addClass('section-grillen-hero--sticky-bar-visible');
		});

		footerWatcher.enterViewport(() => {
			$section.
				addClass('section-grillen-hero--sticky-bar-hidden');
		});

		footerWatcher.exitViewport(() => {
			$section.
				removeClass('section-grillen-hero--sticky-bar-hidden');
		});
	}

	// Parallax effect
	// ref https://ihatetomatoes.net/demos/parallax-scroll-effect/
	if ($section.hasClass('section-grillen-hero--background-parallax-enabled')) {
		const parallaxFactor = $section.data('background-parallax-factor');
		const $background = $section.find('.section-grillen-hero__background');
		let sectionHeight = $section.height();

		if ($section.index() === 0) {
			sectionHeight = sectionHeight + 90; // Include header if first section
		}

		$window.on('scroll', (e) => {
			let sectionScrollTop = Math.max(0, Math.min(sectionHeight, $window.scrollTop())); // Clamp
			let y = sectionScrollTop * parallaxFactor;

			$background.css('transform', 'translateY(' + y + 'px)');
		});

		$window.on('resize', (e) => {
			sectionHeight = $section.height();

			if ($section.index() === 0) {
				sectionHeight = sectionHeight + 90;
			}
		});
	}
});

// Section grillen menus
$('.section-grillen-menus').each(function(index, el) {
	const $section = $(el);
	const initalBackgroundColor = $section.css('background-color');
	const initialForeGroundColor = $section.hasClass('text-dark') ? 'text-dark' : 'text-light';

	$section.find('button.tabs__tab').on('click', () => {
		const $tab = $section.find('.tabs__panel:not([hidden="hidden"])');
		const $menuPage = $tab.find('.menu-page')

		if ($menuPage.data('background-color')) {
			$section.css('background-color', $menuPage.data('background-color'));
		} else {
			$section.css('background-color', initalBackgroundColor);
		}

		$section.removeClass('text-dark text-light');

		if ($menuPage.data('foreground-color')) {
			$section.addClass('text-' + $menuPage.data('foreground-color'));
		} else {
			$section.addClass(initialForeGroundColor);
		}
	});
});

// Section grillen stories slider
$('.section-grillen-stories').each(function(index, el) {
	const $section = $(el);
	const offset = () => {
		return 0;
		return ($section.find('.container-wide').width() - $section.find('.container').width()) / 2;
	};

	// Duplicate the slides because of a glitch with looped swiper and to few slides
	if ($section.find('.swiper-slide').length < 9) {
		$section.find('.swiper-wrapper').append($section.find('.swiper-wrapper').html());
		$section.find('.swiper-wrapper').append($section.find('.swiper-wrapper').html());
	}

	new Swiper($section.find('.swiper').get(0), {
		loop: true,
		centeredSlides: true,
		slidesPerView: 1.2,
		spaceBetween: 20,
		slidesOffsetBefore: offset(),
		slidesOffsetAfter: offset(),
		breakpoints: {
			768: {
				slidesPerView: 2.5
			}
		},
		on: {
			resize: (s) => {
				s.params.slidesOffsetBefore = offset();
				s.params.slidesOffsetAfter = offset();
			}
		},
		simulateTouch: false,
		navigation: {
			nextEl: $section.find('.section-grillen-stories__slider__next').get(0),
			prevEl: $section.find('.section-grillen-stories__slider__prev').get(0)
		},
	});
});

// Popup
$document.on('click', 'button[data-action="open-popup"]', function(e) {
	window.location.hash = $(e.target).data('popup-id');
});

$document.on('click', '.btn[data-action="close-popup"]', function(e) {
	history.pushState(null, null, ' ');
	$window.trigger('hashchange');
});

$document.on('click', '.popup', function(e) {
	if ($(e.target).hasClass('popup')) {
		history.pushState(null, null, ' ');
		$window.trigger('hashchange');
	}
});

$document.on('keyup', function(e) {
	if (e.keyCode === 27) {
		if ($('.popup--active').length > 0) {
			history.pushState(null, null, ' ');
			$window.trigger('hashchange');
		}
	}
});

$window.on('hashchange', function(e) {
	if (window.location.hash) {
		let $popup = $('.popup[data-id="' + window.location.hash + '"]');

		if ($popup.length > 0) {
			$popup.addClass('popup--active').focus();
			$body.addClass('body--lock-scroll');
		}
	} else {
		let $popup = $('.popup--active');

		if ($popup.length > 0) {
			$popup.removeClass('popup--active');
			$body.removeClass('body--lock-scroll');
		}
	}
});

if (window.location.hash) {
	$window.trigger('hashchange');
}
